module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-woman-40_b59749b142811ba499df95909fea5eaa.png";